/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Properties with these hard references are
 * referenced and required by places in the
 * application.
 */
export enum ReferenceTypeEnum {
    LOAN_SECURITY_AGREEMENT = 'Loan & Security Agreement',
    COMPLIANCE_CERTIFICATE = 'Compliance Certificate',
    ACCOUNT_CONTROL_AGREEMENT = 'Account Control Agreement',
    ACCOUNT_CONTROL_AGREEMENT_TERMINATION = 'Account Control Agreement Termination',
    FINANCIAL_STATEMENTS = 'Financial Statements',
    DS_RE_UPLOADED_FINANCIALS = 'DS Re-uploaded Financials',
    ENTITY_GOVERNANCE = 'Entity Governance',
    IN_COMPLIANCE = 'IN_COMPLIANCE',
    ACTUAL = 'ACTUAL',
    THRESHOLD = 'THRESHOLD',
}
